<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-address-card me-2"></i>Kontakte ({{totalEntries}})</h1>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/contact', 0]">Kontakt anlegen</button>

<pagination
        [hidden]="entries?.length == 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste">
</pagination>

<div class="table-responsive">
    <table class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.name" [class.search-active]="search.name != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th>
                <input type="text" class="form-control" [(ngModel)]="search.phone" [class.search-active]="search.phone != ''" appDebounceKeyup (debounceKeyup)="checkFilterAndList()">
            </th>
            <th></th>
            <th></th>
        </tr>
        <tr>
            <th (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('zip')">
                PLZ <i class="fas" *ngIf="predicate == 'zip'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('city')">
                Ort <i class="fas" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('street')">
                Straße <i class="fas" *ngIf="predicate == 'street'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('phone')">
                Telefon <i class="fas" *ngIf="predicate == 'phone'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('mail')">
                E-Mail <i class="fas" *ngIf="predicate == 'mail'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('customer')">
                Kunde <i class="fas" *ngIf="predicate == 'customer'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/contact', entry.id]">
            <td>{{ entry.name }}</td>
            <td>
                {{ entry.zip }}
                <span class="text-muted" *ngIf="!entry.zip">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.city }}
                <span class="text-muted" *ngIf="!entry.city">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.street }}
                <span class="text-muted" *ngIf="!entry.street">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.phone }}
                <span class="text-muted" *ngIf="!entry.phone">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.mail }}
                <span class="text-muted" *ngIf="!entry.mail">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.customer }}
                <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
